import { IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonText, IonTextarea, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { alarmOutline, chevronBackOutline, locationOutline, removeCircleOutline, trashOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

interface RouteParams {
    token: string;
}

const PlaceEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [place, setPlace] = useState<any>({});
    const [nameEdit, setNameEdit] = useState<boolean>(false);
    const [locationEdit, setLocationEdit] = useState<boolean>(false);
    const [propertyEdit, setPropertyEdit] = useState<boolean>(false);
    const [timezoneEdit, setTimezoneEdit] = useState<boolean>(false);      
    const [mapLinkEdit, setMapLinkEdit] = useState<boolean>(false);
    const [phoneEdit, setPhoneEdit] = useState<boolean>(false);
    const [placePhone, setPlacePhone] = useState<string>('');
    const [connectEdit, setConnectEdit] = useState<boolean>(false);
    const [otherEdit, setOtherEdit] = useState<boolean>(false);
    const [notesEdit, setNotesEdit] = useState<boolean>(false);

    const { networkStatus, getAppStatus, authKey, authenticateMember, accountSetupPct, alarms, setShowLoader, limits, profiles, settings, userIANATimezone, timezoneIANAName, timezonesIANA, countries, getTimezonesIANA, getCountries, SWFullHorizLogo, SWTextDarkLogo, nl2br, showToast, present, dismiss } = useAppContext();

    const [showAlert] = useIonAlert();
    
    const phoneInputRef = useRef<any>();
    const { token } = useParams<RouteParams>();
    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if(!authenticated || authenticated.mt == '') {
                    router.push('/login', 'forward');
                } else {
                    await getCountries();
                    if (timezonesIANA.length === 0) await getTimezonesIANA();  
                    await getPlace(token, authenticated.mt);
                    window.setTimeout(() => {
                        setShowLoader(false);
                    }, 1000);
                }
            }
        };
        authenticate();
    }); 

    useEffect(() => {
        // Strip the country code from placePhone
        const phoneWithCountryCode = `${place.placePhone}`; 
        const countryCode = `${place.placePhoneCode}`;
        const phoneWithoutCountryCode = phoneWithCountryCode != '' && phoneWithCountryCode != '' ? phoneWithCountryCode.replace(new RegExp('^\\' + countryCode), '') : '';        
        setPlacePhone(phoneWithoutCountryCode);
    }, [place]);

    useEffect(() => {
        //console.log(timezones);                    
    }, [timezonesIANA]);

    const toggleNameForm = () => setNameEdit(!nameEdit);
    const toggleLocationForm = () => setLocationEdit(!locationEdit);
    const togglePropertyForm = () => setPropertyEdit(!propertyEdit);
    const toggleTimezoneForm = () => setTimezoneEdit(!timezoneEdit);
    const toggleMapLinkForm = () => setMapLinkEdit(!mapLinkEdit);
    const togglePhoneForm = () => setPhoneEdit(!phoneEdit);
    const toggleConnectForm = () => setConnectEdit(!connectEdit);
    const toggleOtherForm = () => setOtherEdit(!otherEdit);
    const toggleNotesForm = () => setNotesEdit(!notesEdit);

    const getPlace = async (pt: string, mt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('pt', pt);
            const response = await fetch('https://api.besolowise.com/places/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                
                if(typeof obj.placeID == 'number') {
                    setPlace(obj); 
                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 3000,
                        color: 'danger',
                        position: 'middle'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 5000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue;
    };

    const updatePlace = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('formName', formName);
        formData.append('token', token);
        formData.append('mt', authKey.mt);

        try {
            const response = await fetch('https://api.besolowise.com/places/update/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    getPlace(obj.pt, authKey.mt);
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    document.getElementById(formName + 'Cancel')?.click();
                    showToast({
                        message: 'SAVED',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error 1: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'danger',
                });
            }            
        } catch(error) {
            btn.innerHTML = 'Save';
            btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: ' + error,
                duration: 5000,
                color: 'danger',
            });
        } 
    };

    const deletePlace = () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Place?',
            buttons: [
                { text: 'Cancel',
                  role: 'cancel',
                  cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Remove',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('token', token);
                            formData.append('mt', authKey.mt);
                            const response = await fetch('https://api.besolowise.com/places/delete/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    router.push('/account/places', 'back');
                                } else {
                                    showToast({
                                        message: 'Error: ' + obj.message,
                                        duration: 4500,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response error.',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const DSTChip = (s: string) => {
        switch(s) {
            case '0': return <IonText slot='end' color={'medium'}>Never DST</IonText>
            case '1': return <IonText slot='end' color={'warning'}>Seasonal DST</IonText>
            case '2': return <IonText slot='end' color={'success'}>Always DST</IonText>
        }
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            await getPlace(token, authKey.mt);
            event.detail.complete();
            setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/places'>Places</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='PlaceContent'>
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={locationOutline}></IonIcon> 
                                {place.placeName}
                                <br /><span>Editing a Saved Place</span>
                            </h1>                            
                        </IonCol>
                    </IonRow>
                </IonGrid>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleNameForm}><b>Place Name</b> <em className='required'>Required</em></IonLabel>
                        { nameEdit 
                            ? (<form name='nameForm' onSubmit={updatePlace}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonInput counter fill='outline' name='placeName' placeholder='Name' type='text' value={place.placeName} maxlength={50}></IonInput>
                                            </IonCol>                               
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='nameFormCancel' onClick={toggleNameForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='nameFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleNameForm}>{place.placeName}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleTimezoneForm}><b>Timezone</b> <em className='required'>Required</em></IonLabel>
                        { timezoneEdit 
                            ? (<form name='timezoneForm' onSubmit={updatePlace}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='placeTimezone' placeholder='Timezone of this place' value={place.placeIANATimezone}>
                                                    {timezonesIANA.map((zone: any, index: number) => (
                                                        <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                    ))}                                             
                                                </IonSelect>
                                            </IonCol>                               
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='timezoneFormCancel' onClick={toggleTimezoneForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='timezoneFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleTimezoneForm}>{timezoneIANAName(place.placeIANATimezone)} Time</p>
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleLocationForm}><b>Address / Location</b> <em className='required'>Required</em></IonLabel><br />                        
                        { locationEdit  
                            ? (<form name='locationForm' onSubmit={updatePlace}>
                                    <IonNote>This can be a Street Address, GPS Coordinates, or just a good description.</IonNote>
                                    <IonTextarea autoGrow fill='outline' name='placeLocation' placeholder='' value={place.placeLocation}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='locationFormCancel' onClick={toggleLocationForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='locationFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleLocationForm}>{place.placeLocation == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(place.placeLocation) }} />)}</p>
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={togglePropertyForm}><b>Property and Environment</b></IonLabel>
                        { propertyEdit 
                            ? (<form name='propertyForm' onSubmit={updatePlace}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel>Type of Property</IonLabel>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='placePropertyType' placeholder='' value={place.placePropertyType}>
                                                    <IonSelectOption value=''>Unknown</IonSelectOption>
                                                    <IonSelectOption value='Public'>Public</IonSelectOption> 
                                                    <IonSelectOption value='Private'>Private</IonSelectOption>                                           
                                                </IonSelect>
                                            </IonCol>                               
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel>Type of Environment</IonLabel>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='placeEnvType' value={place.placeEnvType}>
                                                    <IonSelectOption value=''>Unknown</IonSelectOption>
                                                    <IonSelectOption value='Urban'>Urban</IonSelectOption>
                                                    <IonSelectOption value='Suburban'>Suburban</IonSelectOption> 
                                                    <IonSelectOption value='Rural'>Rural</IonSelectOption>
                                                    <IonSelectOption value='Wilderness'>Wilderness</IonSelectOption>                          
                                                </IonSelect>
                                            </IonCol>                               
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='propertyFormCancel' onClick={togglePropertyForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='propertyFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={togglePropertyForm}>{place.placePropertyType == '' && place.placeEnvType == '' ? (<>Not Recorded</>) : (<>{place.placePropertyType} {place.placeEnvType}</>)}</p>
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleMapLinkForm}><b>Google Map Link</b></IonLabel>
                        { mapLinkEdit  
                            ? (<form name='mapLinkForm' onSubmit={updatePlace}> 
                                    <IonTextarea autoGrow fill='outline' name='placeMapLink' value={place.placeMapLink}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='mapLinkFormCancel' onClick={toggleMapLinkForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='mapLinkFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleMapLinkForm}>{place.placeMapLink == '' ? (<>Not Recorded</>) : (<>{place.placeMapLink}</>)}</p>
                        }
                    </IonCardContent>
                </IonCard>                 
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={togglePhoneForm}><b>Landline Phone</b></IonLabel>
                        { phoneEdit  
                            ? (<form name='phoneForm' onSubmit={updatePlace}>
                                    <IonSelect fill='outline' labelPlacement='stacked' name='placePhoneCode' placeholder='Country Code' value={place.placePhoneCode}>
                                        <IonSelectOption value='+1'>+1 (United States / Canada)</IonSelectOption>
                                        {countries.map((country:any, index:number) => (
                                            <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                                        ))}
                                    </IonSelect>
                                    <IonInput className='ion-margin-top' fill='outline' name='placePhone' onKeyUp={formatPhone} placeholder='Phone Number' ref={phoneInputRef} type='tel' value={placePhone === undefined ? '' : placePhone}></IonInput>                                
                                    <IonButton className='ion-margin-top' color={'medium'} id='phoneFormCancel' onClick={togglePhoneForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='phoneFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={togglePhoneForm}>{place.placePhone == '' ? (<>Not Recorded</>) : (<>{place.placePhone}</>)}</p>
                        }
                    </IonCardContent> 
                </IonCard>

                <IonCard className='ion-margin-bottom'>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleConnectForm}><b>Cellular or Internet connection is available</b></IonLabel>
                        { connectEdit 
                            ? (<form name='connectForm' onSubmit={updatePlace}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='placeConnectivity' placeholder='Select an option' value={place.placeConnectivity}>
                                                    <IonSelectOption value='Yes'>Yes</IonSelectOption>
                                                    <IonSelectOption value='No'>No</IonSelectOption> 
                                                    <IonSelectOption value='Unknown'>Unknown</IonSelectOption>
                                                </IonSelect>
                                            </IonCol>                               
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='connectFormCancel' onClick={toggleConnectForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='connectFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            :<p onClick={toggleConnectForm}>{place.placeConnectivity == '' ? (<>Not Recorded</>) : (<>{place.placeConnectivity}</>)}</p>
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel>
                        { notesEdit  
                            ? (<form name='notesForm' onSubmit={updatePlace}> 
                                    <IonText><p>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</p></IonText>
                                    <IonTextarea autoGrow fill='outline' name='placeNotes' value={place.placeNotes}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='notesFormCancel' onClick={toggleNotesForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='notesFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleNotesForm}>{place.placeNotes == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(place.placeNotes) }} />)}</p>
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleOtherForm}><b>Other Information</b></IonLabel>
                        { otherEdit  
                            ? (<form name='otherForm' onSubmit={updatePlace}> 
                                    <IonTextarea autoGrow fill='outline' name='placeOtherInfo' value={place.placeOtherInfo}></IonTextarea>
                                    <IonButton className='ion-margin-top' color={'medium'} id='otherFormCancel' onClick={toggleOtherForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='otherFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleOtherForm}>{place.placeOtherInfo == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(place.placeOtherInfo) }} />)}</p>
                        }
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    {accountSetupPct === 100 && alarms < limits.timers &&
                    <IonButton className='ion-margin' color={'tertiary'} fill="outline" routerLink={`/account/timer/create/?place=${token}`} routerDirection='forward'><IonIcon icon={alarmOutline} slot='start'></IonIcon> Add to a New Timer</IonButton>}
                    <IonButton className='ion-margin delete-button-outline' color={'remove'} fill="outline" onClick={deletePlace}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove This Place</IonButton>
                </div>

            </IonContent>
        </IonPage>
    );
};

export default PlaceEdit;
